import React from 'react';
import ErrorPage from './ErrorPage';

const NotFoundPage = () => {
    return (
        <ErrorPage className='not-found-page'>
            Page not found
        </ErrorPage>
    );
};

export default NotFoundPage;


// WEBPACK FOOTER //
// ./src/containers/template/NotFoundPage.js